import { InjectionToken } from '@angular/core';
import type { MenuItem } from './main-menu-config.type';
import type { AdminUserRole } from '../../backend/main';

export const TOP_RIGHT_MENU_CONFIG_TOKEN = new InjectionToken<MenuItem<AdminUserRole>[]>(
  'TOP_RIGHT_MENU_CONFIG_TOKEN',
);
